module.exports = __webpack_public_path__ + "static/media/prakash-pandey.0151adbc.png";